var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.101,
    height: 14.399,
    viewBox: "0 0 12.101 14.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#aac148;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.973 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.936,136.395h-7.3a.294.294,0,0,0-.294.294v6.125a.294.294,0,0,0,.294.294h1.3v2.064a.867.867,0,0,0,.867.867h0a.867.867,0,0,0,.867-.867v-2.064h1.213v2.064a.867.867,0,0,0,.867.867h0a.867.867,0,0,0,.867-.867v-2.064h1.32a.294.294,0,0,0,.294-.294v-6.125A.294.294,0,0,0,100.936,136.395Z",
    transform: "translate(-58.261 -131.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.84,136.354h0a.867.867,0,0,0-.867.867v3.522a.867.867,0,0,0,.867.867h0a.867.867,0,0,0,.867-.867v-3.522A.867.867,0,0,0,33.84,136.354Z",
    transform: "translate(0 -131.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M331.265,136.354h0a.867.867,0,0,0-.867.867v3.522a.867.867,0,0,0,.867.867h0a.867.867,0,0,0,.867-.867v-3.522A.867.867,0,0,0,331.265,136.354Z",
    transform: "translate(-287.059 -131.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M95.32,4.324h7.169a.3.3,0,0,0,.288-.355,3.963,3.963,0,0,0-1.933-2.633L101.456.23a.155.155,0,0,0-.271-.15l-.617,1.114a3.966,3.966,0,0,0-3.327,0L96.623.08a.155.155,0,1,0-.271.15l.613,1.106a3.963,3.963,0,0,0-1.933,2.633A.3.3,0,0,0,95.32,4.324Zm5.723-1.648a.333.333,0,1,1-.333-.333A.333.333,0,0,1,101.043,2.676ZM97.1,2.343a.333.333,0,1,1-.333.333A.333.333,0,0,1,97.1,2.343Z",
    transform: "translate(-59.89)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.5cc11bc5.svg";
export { ForwardRef as ReactComponent };